import React from "react";
import { Helmet } from "react-helmet";

const MetaDetails = ({ title, description, favicon }) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {favicon && <link rel="icon" href={favicon} />}
      </Helmet>
    </>
  );
};

export default MetaDetails;
